import _get from 'lodash/get';
import Storage from 'grab-storage';
import {
  LOGIN,
  LOGOUT,
  GRAB_ID_LOGOUT,
  FETCH_USER_INFO,
  LINK_COMPANY,
  ATHORIZATION_ACTIONS,
  GET_USER_CONFIGURATION,
  GET_LKPP_TOKEN,
  PAX_FETCH_BUSINESS_PROFILES,
  PAX_FETCH_USER_CONFIGURATION,
  GET_COMPANY_PERMISSIONS,
  GET_COMPANY_USER_PROFILES,
  FETCH_PORTAL_USER_PROFILES,
} from './endpoint-constants';

const getLoginEpt = () => {
  const { endpoints } = window.Grab.config;
  const { gfbAPI } = endpoints;
  return `${gfbAPI}${LOGIN}`;
};

const getLogoutEpt = () => {
  const { endpoints } = window.Grab.config;
  const { gfbAPI } = endpoints;
  return `${gfbAPI}${LOGOUT}`;
};

const getGFBLogoutEpt = () => {
  const { endpoints } = window.Grab.config;
  const grabIdAPIBase = _get(endpoints, 'grabIdAPIBase');

  return `${grabIdAPIBase}${GRAB_ID_LOGOUT}`;
};

const getGFBUserEpt = () => {
  const { endpoints } = window.Grab.config;
  const lkppAPI = _get(endpoints, 'lkppAPI');

  return `${lkppAPI}/v1${FETCH_USER_INFO}`;
};

const getUserNameEpt = () => {
  const { endpoints } = window.Grab.config;
  const { gfbPortalAPI } = endpoints;
  return `${gfbPortalAPI}/v1/user`;
};

const getAuthorizationEpt = (params = {}) => {
  const { endpoints } = window.Grab.config;
  const { lkppAPI, gfbAPI } = endpoints;

  // These are 2 hosts pointing to the same endpoint, but only portal accepts Cookie Auth
  // Gfb (enterprise-api) and lkpp (portal) are both owned by GFB.
  const domain =
    Storage.getItem('__AUTH_HINT__') === 'COOKIE' ? lkppAPI : gfbAPI;

  const baseUrl = `${domain}${ATHORIZATION_ACTIONS}`;
  const paramKeys = Object.keys(params);
  if (paramKeys.length > 0) {
    let url = `${baseUrl}?`;
    paramKeys.forEach((key, index) => {
      if (index !== 0) url += '&';
      url += `${key}=${params[key]}`;
    });
    return url;
  }
  return baseUrl;
};

const getUserConfiguration = (companyID, cityCode, cityID) => {
  const { endpoints } = window.Grab.config;
  const { geAPI } = endpoints;
  let url = `${geAPI}${GET_USER_CONFIGURATION}?companyId=${companyID}`;
  if (cityCode) {
    url += `&cityCode=${cityCode}`;
  }
  if (cityID) {
    url += `&cityID=${cityID}`;
  }
  return url;
};

const paxGetUserConfiguration = (countryCode, cityCode, cityID) => {
  const { endpoints } = window.Grab.config;
  const { geAPIV2 } = endpoints;
  let url = `${geAPIV2}${PAX_FETCH_USER_CONFIGURATION}?input.countryCode=${countryCode}`;
  if (cityCode) {
    url += `&input.cityCode=${cityCode}`;
  }
  if (cityID) {
    url += `&input.cityID=${cityID}`;
  }
  return url;
};

const getExchangeToken = nonce => {
  const { endpoints } = window.Grab.config;
  const { lkppAPI } = endpoints;
  return `${lkppAPI}${GET_LKPP_TOKEN}?nonce=${nonce}`;
};

const paxFetchBusinessProfilesEpt = countryCode => {
  const { endpoints } = window.Grab.config;
  const { geAPI } = endpoints;
  return `${geAPI}${PAX_FETCH_BUSINESS_PROFILES}?input.countryCode=${countryCode}`;
};

/* Endpoints for GFB accounts */

const getLinkCompanyEpt = () => {
  const { endpoints } = window.Grab.config;
  const { geAPI } = endpoints;
  return `${geAPI}${LINK_COMPANY}`;
};

const getCompanyPermissionsEpt = () => {
  const { endpoints } = window.Grab.config;
  const { geAPI } = endpoints;
  return `${geAPI}${GET_COMPANY_PERMISSIONS}`;
};

const getCompanyUserProfilesEpt = () => {
  const { endpoints } = window.Grab.config;
  const { geAPI } = endpoints;
  return `${geAPI}${GET_COMPANY_USER_PROFILES}`;
};

// TODO: enterprise-api is not used anymore. Deprecate this function.
// This function will be replaced by getCompanyUserProfilesEpt
const fetchUserInfoEpt = () => {
  const { endpoints } = window.Grab.config;
  const { lkppAPI, gfbAPI } = endpoints;

  // These are 2 hosts pointing to the same endpoint, but only portal accepts Cookie Auth
  // Gfb (enterprise-api) and lkpp (portal) are both owned by GFB.
  const domain =
    Storage.getItem('__AUTH_HINT__') === 'COOKIE' ? lkppAPI : gfbAPI;

  return `${domain}${FETCH_PORTAL_USER_PROFILES}`;
};

export default {
  getLoginEpt,
  getLogoutEpt,
  getGFBLogoutEpt,
  getGFBUserEpt,
  fetchUserInfoEpt,
  getLinkCompanyEpt,
  getUserNameEpt,
  getAuthorizationEpt,
  getUserConfiguration,
  paxGetUserConfiguration,
  getExchangeToken,
  paxFetchBusinessProfilesEpt,
  getCompanyPermissionsEpt,
  getCompanyUserProfilesEpt,
};
